// extracted by mini-css-extract-plugin
export default {"container":"DocumentViewer_container__3WWum","pdfContainer":"DocumentViewer_pdfContainer__J5BrB"};